/* global G */

import { debounce } from 'lib/util'
import { findPosition } from 'platform/adapter/cart/helper'

/**
 * Adds an article to the user's active cart, incrementing the amount if the article is
 * already present. Triggers `G.CART, G.CREATE` first when the user has no active cart yet.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @returns {AttachmentEventListener}  an AttachmentEventListener
 */
const fn = app => async ({ detail = {} }) => {
  const { key, name, data } = detail[G.DATA]

  const adapter = app[G.ADAPTER][G.CART]
  const activeCart = adapter[G.DATA]
  const eventBus = app[G.ADAPTER][G.EVENTS]

  // User has no active cart, let's create one
  if (!activeCart) {
    eventBus.dispatch(eventBus.type(G.CART, G.CREATE), { [G.DATA]: { data } })
    return
  }

  // TODO: Ask Demis why `key` isn't enough. Different positions can have the same `name`.
  activeCart.value.positions = !findPosition(activeCart.value.positions, { key /* , name */ })
    ? activeCart.value.positions.concat(data)
    : activeCart.value.positions.map(position => (
      key && key === position?.key // || name === position?.name
        ? { ...position, amount: position.amount + 1 }
        : position))

  eventBus.dispatch(eventBus.type(G.CART, G.SET), { [G.DATA]: activeCart })
}

export default app => debounce(fn(app), 300, false)
